
// FIX: Correct variant image switching - uses Slick native instance
// Fixes bug where clicking color swatch doesn't update main product image
(function() {
  function switchToVariantImage(variantId) {
    var variantData = null;
    document.querySelectorAll('script[type="application/json"]').forEach(function(script) {
      if (variantData) return;
      try {
        var d = JSON.parse(script.textContent);
        if (Array.isArray(d) && d.length > 0 && typeof d[0].featured_media !== 'undefined') {
          variantData = d;
        }
      } catch(e) {}
    });
    if (!variantData) return;
    var variant = null;
    for (var i = 0; i < variantData.length; i++) {
      if (variantData[i].id == variantId) { variant = variantData[i]; break; }
    }
    if (!variant || !variant.featured_media) return;
    var targetMediaId = variant.featured_media.id;
    var mainSliderEl = document.querySelector('.main-product-image-slider');
    if (!mainSliderEl || !mainSliderEl.slick) return;
    var targetIndex = null;
    var slides = mainSliderEl.querySelectorAll('.slick-slide:not(.slick-cloned)');
    for (var j = 0; j < slides.length; j++) {
      var inner = slides[j].querySelector('[data-media-id="' + targetMediaId + '"]');
      if (inner) {
        var idx = parseInt(slides[j].getAttribute('data-slick-index'));
        if (!isNaN(idx) && idx >= 0) { targetIndex = idx; break; }
      }
    }
    if (targetIndex !== null) {
      mainSliderEl.slick.slickGoTo(targetIndex, false);
      var thumbSlider = document.querySelector('.main-product-thumbnail-image-slider');
      if (thumbSlider && thumbSlider.slick) {
        thumbSlider.slick.slickGoTo(targetIndex, false);
      }
    }
  }

  document.addEventListener('change', function(e) {
    if (e.target && e.target.classList && e.target.classList.contains('productOption')) {
      setTimeout(function() {
        var urlParams = new URLSearchParams(window.location.search);
        var variantId = urlParams.get('variant');
        if (!variantId) {
          var inp = document.querySelector('input[name="id"], select[name="id"]');
          variantId = inp ? inp.value : null;
        }
        if (variantId) switchToVariantImage(variantId);
      }, 200);
    }
  });
})();
